import { useForm } from "@refinedev/antd";
import { HttpError, useCreate, useNavigation } from "@refinedev/core";
import { PayloadConfigType } from "../intelligence-search/component/crud/save-config-component";
import { IntelligenceSearchV2 } from "./list";
import { CrudActionButton } from "./components/crud";
import { ExplorationType } from "../ab-test-explore/enum/exploration-types.enum";
import { getUserInfo } from "@src/util/get-user-info";
import { ConfigTextEditor, ModeSave } from "@src/components/intelligence-search/crud-component/modal-save";
import React from "react";
import { LayoutWrapper } from "./components/crud/layout-wrapper";
import { Form } from "antd";

const DEFAULT_TITLE = "Intelligence Search";
export const IntelligenceSearchV2Create = () => {
    const { replace } = useNavigation();
    const { form } = useForm<any, HttpError, any>();

    const { mutateAsync: createISConfig, isLoading: isLoadingCreateISConfig } = useCreate();

    const handleSave = async (
        values: { title: string; description: string },
        _?: ModeSave,
        queryOptions?: {
            onSuccess?: (data: any) => void;
            onError?: () => void;
            onSettled?: () => void;
        },
    ) => {
        const userInfo = getUserInfo();
        const formValues = form.getFieldsValue();
        const productCode = formValues?.product_code;

        const payload: PayloadConfigType = {
            title: values.title,
            description: values.description,
            owner: userInfo?.email,
            config: formValues,
            type: ExplorationType.INTELLIGENCE_SEARCH_V2,
            product_code: productCode,
        };

        createISConfig({
            resource: "explorations",
            values: payload,
            dataProviderName: "nestjsx",
            successNotification: {
                type: "success",
                message: "Successfully created",
                description: "Your explore have been created",
            },
            meta: {
                headers: {
                    "product-code": payload.product_code,
                },
            },
        })
            .then((data) => {
                queryOptions?.onSuccess?.(data);
                if (data?.data?.id) {
                    replace(`/explorations/intelligence-searches/${data?.data?.id}`);
                }
            })
            .catch((error) => {
                queryOptions?.onError?.();
            })
            .finally(() => {
                queryOptions?.onSettled?.();
            });
    };
    const [modalValues, setModalValues] = React.useState<{ title: string; description: string }>({
        title: DEFAULT_TITLE,
        description: "",
    });
    const [isPreventAutoUpdateTitle, setIsPreventAutoUpdateTitle] = React.useState(false);
    const productCodeWatch = Form.useWatch("product_code", form);
    React.useEffect(() => {
        if (!productCodeWatch || isPreventAutoUpdateTitle) return;
        setModalValues((prev) => ({
            ...prev,
            title: DEFAULT_TITLE + " - " + productCodeWatch,
        }));
    }, [productCodeWatch, isPreventAutoUpdateTitle]);
    return (
        <LayoutWrapper
            headerActions={
                <CrudActionButton
                    isCreate={true}
                    modalValuesProps={modalValues}
                    handleSave={handleSave}
                    initConfigProps={{
                        title: "Intelligence Search",
                        description: "",
                    }}
                    form={form}
                    isOwnerConfig={false}
                />
            }
            title={
                <div className="flex flex-col">
                    <div className="flex items-center">
                        <div className="font-bold text-[18px]">{modalValues?.title}</div>
                        <ConfigTextEditor
                            initValues={modalValues}
                            onConfirmValuesChange={(values) => {
                                setModalValues(values);
                                setIsPreventAutoUpdateTitle(true);
                            }}
                        />
                    </div>
                    <div className=" text-[14px] text-gray-500">{modalValues?.description}</div>
                </div>
            }
            loading={isLoadingCreateISConfig}
            isDisabled={false}
        >
            <IntelligenceSearchV2 form={form} />
        </LayoutWrapper>
    );
};
